/* tslint:disable:no-require-imports no-var-requires */
/* eslint-disable global-require */
import {Boot, Context} from '@/project'
import _axios, {AxiosInstance, AxiosRequestConfig} from 'axios'
import AxiosTransforms, {TransformsOptions} from '@/lib/axiosAddTransforms'

declare module 'vue/types/vue' {
  interface Vue {
    $axios: AxiosInstance
  }
}

let _vue

export interface Options {
  transformers?: (context: Context) => TransformsOptions<Context>
  axiosConfig?: AxiosRequestConfig
}

export function clearSavedVue() {
  _vue = null
}

export function axios(context?: Context) {
  if(context) {
    return context.Vue.prototype.$axios
  }
  if(_vue) {
    return _vue.prototype.$axios
  }
  throw new Error('[boot/axios] It cannot return axios instance. ' +
    'You should run boot function before')
}

/**
 * boot axios with options
 * apply AxiosTransforms the axios
 * @param context
 * @param options
 */
const boot: Boot = (context, options: Options) => {
  const {Vue} = context
  const {axiosConfig, transformers} = options
  const {$axios} = Vue.prototype
  if($axios) {
    return
  }
  const myAxios = _axios.create(axiosConfig)

  if(transformers) {
    const axiosTransforms = new AxiosTransforms(transformers(context))
    axiosTransforms.applyTransform(myAxios)
  }
  _vue = Vue
  Vue.prototype.$axios = myAxios
}

export default boot
